export default "__VITE_ASSET__B1ivYxlQ__"